export default __webpack_public_path__ + "static/media/block-3.d264c620.jpg";